// src/components/GoogleAuth.js
import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';

export default function GoogleAuth() {
  const { login } = useAuth();
  const navigate  = useNavigate();

  return (
    <GoogleLogin
      width="100%"
      shape="rectangular"
      text="signin_with"
      locale="pt-BR"
      onSuccess={async ({ credential }) => {
        if (!credential) return;       // defesa extra
        await login(credential);       // 🔸 1 único parâmetro
        navigate('/onboarding');
      }}
      onError={() => console.log('Google Auth erro')}
    />
  );
}